// know brands, by default brand is 'Husqvarna Group'
const SUPPORTED_BRANDS: Record<string, string> = {
  gardena: 'gardena'
};
export const BRAND_STORAGE_KEY = 'brand';

export function isGardenaBrand(value: string): boolean {
  return value.toLowerCase() === 'gardena';
}

/**
 * Determine brand from provided brand
 * @param {string} providedBrand - Brand provided by user.
 * @returns {string} - Determined brand
 */
export function determineBrand(providedBrand: string | null) {
  const lowerCaseProvidedBrand = providedBrand?.toLowerCase();
  return lowerCaseProvidedBrand && SUPPORTED_BRANDS[lowerCaseProvidedBrand]
    ? lowerCaseProvidedBrand
    : '';
}
